import { FC, Fragment, ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// Mui
import { Box } from '@mui/material';
// Utilities
import { getSearchParam } from 'app/utilities/Utilities';
// 
import BillingAndSubscriptionsToolbar from './BillingAndSubscriptionsToolbar';
import InvoicesTabContent from './InvoicesTabContent';
import UsageReportTabContent from './UsageReportTabContent';
import CostExplorerTabContent from './CostExplorerTabContent';
import SubscriptionsTabContent from './SubscriptionsTabContent';
import BillingPreferencesTabContent from './BillingPreferencesTabContent';

const BillingAndSubscriptionsPage:FC = () => {
  const { search } = useLocation();

  const [ activeTab, setActiveTab ] = useState(0);

  useEffect(() => {
    const tab = getSearchParam(search, 'tab');
    setActiveTab(tab ? parseInt(tab) : 0);
  }, [search]);

  const handleChange = (nextActiveTab:number) => {
    setActiveTab(nextActiveTab);
  }

  const renderContent:Record<number, ReactNode> = {
    0: <InvoicesTabContent />,
    1: <UsageReportTabContent />,
    2: <CostExplorerTabContent />,
    3: <SubscriptionsTabContent />,
    4: <BillingPreferencesTabContent />
  };

  return (
    <Fragment>
      <BillingAndSubscriptionsToolbar activeTab={activeTab} onChange={handleChange} />
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }} react-action="scroll">
        {renderContent[activeTab]}
      </Box>
    </Fragment>
  )
}

export default BillingAndSubscriptionsPage;
